import { Injectable } from '@angular/core';
import { BufferSyncAction } from '../models/buffer-sync-action.model';

@Injectable({
  providedIn: 'root',
})
export class BufferService {
  private readonly maxPlaybackRateBonusPercent: number = 40;
  private readonly minPlaybackRateBonusPercent: number = 10;
  private readonly playbackRate: number = 1;
  private readonly toleranceSeconds: number = 1;
  private readonly maxCatchUpDelaySeconds: number = 15;


  getSyncAction(currentTime: number, targetTime: number, playbackRate: number): BufferSyncAction {
    const safePlaybackRate: number = playbackRate > 0 ? playbackRate : this.playbackRate;
    const roundedTargetTime: number = Math.round(targetTime);
    const rawDelay: number = targetTime - currentTime;
    const delay: number = Math.round(roundedTargetTime - currentTime);
    const absoluteDelay: number = Math.abs(rawDelay);

    if (absoluteDelay <= this.toleranceSeconds) {
      return {
        type: 'keep',
        playbackRate: safePlaybackRate,
        delay,
      };
    }

    if (absoluteDelay > this.maxCatchUpDelaySeconds) {
      return {
        type: 'seek',
        targetTime: roundedTargetTime,
        playbackRate: safePlaybackRate,
        delay,
      };
    }

    const direction: number = rawDelay > 0 ? 1 : -1;
    const maxPlaybackRateBonus: number =
      safePlaybackRate * (this.maxPlaybackRateBonusPercent / 100);
    const minPlaybackRateBonus: number =
      safePlaybackRate * (this.minPlaybackRateBonusPercent / 100);
    const playbackRateBonusPerSecond: number = maxPlaybackRateBonus / this.maxCatchUpDelaySeconds;
    const playbackRateBonus: number = Math.min(
      maxPlaybackRateBonus,
      Math.max(minPlaybackRateBonus, absoluteDelay * playbackRateBonusPerSecond),
    );

    return {
      type: direction > 0 ? 'speed-up' : 'slow-down',
      playbackRate: safePlaybackRate + direction * playbackRateBonus,
      delay,
    };
  }
}
